import { HTTP } from '@/modules/shared/helpers/http/facades/http'
import { AfterResponseHook } from 'ky'
import { Notification } from '@/modules/notification/classes/notification'
import { MessageType } from '@/modules/notification/models/types/message.type'

export function httpResponseMessageHook() {
  const handleResponse: AfterResponseHook = async (req, options, res) => {
    const result = await res.json()
    res.json = async () => result

    // console.log('HTTP resp : ', result)

    if (result && typeof result === 'object') {

      if (result.message) {
        // Notification.open({
        //   message: result.message,
        //   type: 'success'
        // })
        if (!('errors' in result)) {
          Notification.show(result.message, (result.exception) ? MessageType.Error : MessageType.Success)
        }
      }
    }
  }
  HTTP.onResponse(handleResponse)
}